import { BubbleMenu as BaseBubbleMenu, Editor } from '@tiptap/react';
import React, { useCallback } from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Divider,
} from '@material-ui/core';
import {
  ArrowLeft,
  ArrowRight,
  Delete,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import { isColumnGripSelected } from './utils';

const TableColumnMenu = React.memo(({ editor, appendTo }) => {
  const shouldShow = useCallback(
    ({ view, state, from }) => {
      if (!state) return false;
      return isColumnGripSelected({
        editor, view, state, from: from || 0,
      });
    },
    [editor],
  );

  const onAddColumnBefore = useCallback(() => {
    editor.chain().focus().addColumnBefore().run();
  }, [editor]);

  const onAddColumnAfter = useCallback(() => {
    editor.chain().focus().addColumnAfter().run();
  }, [editor]);

  const onDeleteColumn = useCallback(() => {
    editor.chain().focus().deleteColumn().run();
  }, [editor]);

  return (
    <BaseBubbleMenu
      editor={editor}
      pluginKey="tableColumnMenu"
      updateDelay={0}
      tippyOptions={{
        appendTo: () => appendTo?.current,
        offset: [0, 15],
        popperOptions: {
          modifiers: [{ name: 'flip', enabled: false }],
        },
      }}
      shouldShow={shouldShow}
    >
      <Paper elevation={3} className="py-2 px-1 w-52">
        <List component="nav" dense>
          <ListItem button onClick={onAddColumnBefore}>
            <ListItemIcon>
              <ArrowLeft fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Add column before" primaryTypographyProps={{ className: 'text-sm' }} />
          </ListItem>

          <ListItem button onClick={onAddColumnAfter}>
            <ListItemIcon>
              <ArrowRight fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Add column after" primaryTypographyProps={{ className: 'text-sm' }} />
          </ListItem>

          <Divider className="my-1" />

          <ListItem button onClick={onDeleteColumn}>
            <ListItemIcon>
              <Delete fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Delete column" primaryTypographyProps={{ className: 'text-sm text-red-600' }} />
          </ListItem>
        </List>
      </Paper>
    </BaseBubbleMenu>
  );
});
const DOMElement = typeof Element !== 'undefined' ? Element : () => {};
TableColumnMenu.displayName = 'TableColumnMenu';
TableColumnMenu.propTypes = {
  editor: PropTypes.instanceOf(Editor).isRequired,
  appendTo: PropTypes.shape({ current: PropTypes.instanceOf(DOMElement) }).isRequired,
};
export default TableColumnMenu;
